import { QuestionnaireService } from './services/questionnaire/questionnaire.service';
import { Component, HostListener, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { APP_VERSION } from 'src/config';
import { AuthService } from './services/auth/auth.service';
import { MixpanelAnalyticsService } from './services/mixpanel-analytics/mixpanel-analytics.service';
import { SentryService } from './services/sentry/sentry.service';
import { UpdateAppService } from './update-app/update-app.service';
import { UploadService } from './services/upload/upload.service';
import { Title } from '@angular/platform-browser';
import { AppConfig } from './app.config';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as duration from 'dayjs/plugin/duration';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as utc from 'dayjs/plugin/utc';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import * as weekOfYear from 'dayjs/plugin/weekOfYear';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent {
  constructor(
    private mixpanel: MixpanelAnalyticsService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authService: AuthService,
    private updateApp: UpdateAppService,
    public router: Router,
    private uploadService: UploadService,
    private sentryService: SentryService,
    private questionnaireSvc: QuestionnaireService,
    private title: Title,
    @Inject(AppConfig) private config: AppConfig
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.setTitle();
    this.listenRoutes();
    this.authService.readToken();
    this.authService.readOrganization();
    this.authService.readIsParticipant();
    this.sentryService.settenantInfo();
    this.initializeDayJS();
    await this.platform.ready();
    if (this.platform.is('cordova')) {
      // istanbul ignore next
      if (this.platform.is('ios')) {
        this.statusBar.styleDefault();
      } else {
        this.statusBar.styleLightContent();
      }
      this.splashScreen.hide();
      await this.updateApp.initialize();
    }
    this.mixpanel.setSuperProperties({ appVersion: APP_VERSION });
  }

  setTitle() {
    this.title.setTitle(this.config.TENANT_NAME);
  }

  listenRoutes() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((v: NavigationEnd) => {
      this.mixpanel.trackUrl(v.urlAfterRedirects);
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler() {
    return !(
      !this.platform.is('cordova') &&
      (this.uploadService.isUploading() || (this.router.url.includes('questionnaire') && this.questionnaireSvc.isCurrentGroupNotSynced()))
    );
  }

  initializeDayJS() {
    dayjs.extend(relativeTime);
    dayjs.extend(customParseFormat);
    dayjs.extend(duration);
    dayjs.extend(isSameOrBefore);
    dayjs.extend(utc);
    dayjs.extend(advancedFormat);
    dayjs.extend(weekOfYear);
  }
}
